<script setup lang="ts">
import UiPicture from '~/components/ui/UiPicture/UiPicture.vue';
import heroImage from '~/assets/images/hero.png';
import heroArrowImage from '~/assets/images/hero-arrow.png';

const heroData = {
    title: 'Разработка программного обеспечения',
    description: 'Полный набор услуг по разработке ПО',
};
</script>

<template>
    <section class="hero">
        <div class="hero__content">
            <UiPicture
                :src="heroImage"
                fetchpriority="high"
                loading="eager"
                decoding="async"
                title="code block"
                class="hero__picture"
            />

            <h1 class="hero__title">{{ heroData.title }}</h1>

            <p class="hero__text">{{ heroData.description }}</p>
        </div>

        <UiPicture
            :src="heroArrowImage"
            title="hero arrow"
            class="hero__right"
        />
    </section>
</template>

<style scoped lang="scss">
    @import 'styles/hero';
</style>
